import { render, staticRenderFns } from "./EnvoiDossier.vue?vue&type=template&id=8c6cc67e&scoped=true&"
import script from "./EnvoiDossier.vue?vue&type=script&lang=js&"
export * from "./EnvoiDossier.vue?vue&type=script&lang=js&"
import style0 from "./EnvoiDossier.vue?vue&type=style&index=0&id=8c6cc67e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6cc67e",
  null
  
)

export default component.exports